export class TeamsService {
  static getRedirectLinkFromFileChatGroup(chatGroupId: string, chatGroupName: string) {
    return `https://teams.microsoft.com/_#/conversations/${chatGroupName}?threadId=${chatGroupId}&ctx=channel`;
  }
}